import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import { isAuthenticated } from '@/utils/auth'
import type { App } from 'vue'

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    return savedPosition || { top: 0 }
  }
})

/** 不需要登录即可访问的白名单 */
const WHITE_LIST = ['/login', '/register']

/* ----------------------------- 全局前置守卫 ----------------------------- */
router.beforeEach((to, _from, next) => {
  // 设置页面标题
  document.title = to.meta.title ? `${to.meta.title} - ${import.meta.env.VITE_APP_TITLE}` : import.meta.env.VITE_APP_TITLE

  const isAuthed = isAuthenticated()
  // meta.login 默认为 true（未显式设置为 false 则需要登录）
  const requiresLogin = to.meta.login !== false

  if (requiresLogin && !isAuthed) {
    // 需要登录但未登录 → 跳转登录页并携带回跳地址
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
    return
  }

  // 已登录用户访问登录页 → 重定向首页
  if (to.path === '/login' && isAuthed) {
    next({ path: '/home' })
    return
  }

  next()
})

/* ----------------------------- 全局后置钩子 ----------------------------- */
router.afterEach((_to, _from) => {
  // 可在此处做埋点、加载完成等处理
})

export function setupRouter(app: App): void {
  app.use(router)
}

export default router
